$(document).ready(function () {
  if($('.product-faqs__item').length > 0){
    $('.product-faqs__item-title-box').on('click', function(){
      $(this).toggleClass('active');
      if ($(this).next().hasClass( "active" )) {
        $(this).next().slideUp(200, function () {
          $(this).toggleClass('active')
        });
      }else {
        $(this).next().slideDown(200, function () {
          $(this).toggleClass('active')
        });
      }
    })
  }
})